import { Settings } from "lucide-react";
import { Brand } from "./Brand";

export function ConfigGate() {
  return <main className="config-gate"><Brand /><section><Settings /><h1>Attendance backend ยังไม่พร้อมใช้งาน</h1><p>ตั้งค่า <code>VITE_SUPABASE_URL</code> และ <code>VITE_SUPABASE_ANON_KEY</code> แล้ว deploy ใหม่ ระบบ production จะไม่ใช้ข้อมูลจำลองแทนหลักฐานเวลา</p></section></main>;
}
